import React, { useState, useEffect } from "react";
import { PDFViewer, Page, Text, View, Document } from "@react-pdf/renderer";
import { Spin } from "antd";
import axios from "axios";
import moment from "moment";
import config from "../../../config";
import PrintHeaderAccount from "../../../Pdf/PrintHeaderAccount";
import PrintFooter from "../../../Pdf/PrintFooter";
import { saleReportStyles } from "../../../Pdf/pdfStyles";
import {
  PrintFormateNumber,
  parseReportAmount,
} from "../../../Pdf/PrintFormateNumber";
import { calculateColumnTotal } from "../../Shared/Utility";

const TABLE_WIDTH = 567;

const NOZZLE_COL = {
  sr: 28,
  product: 90,
  no: 40,
  previous: 100,
  current: 100,
  returned: 100,
  used: 109,
};

const SALE_COL = {
  sr: 28,
  inv: 50,
  customer: 130,
  product: 95,
  vehicle: 55,
  qty: 55,
  price: 55,
  amount: 99,
};

const VOUCHER_COL = {
  sr: 28,
  voucher: 70,
  colA: 110,
  colB: 100,
  desc: 159,
  amount: 100,
};

const fmt = (val, decimals = 0) =>
  PrintFormateNumber(parseReportAmount(val), decimals);

const fmtQty = (val) => PrintFormateNumber(parseReportAmount(val));

/** English left + Urdu right (Vazirmatn) — keep this layout intact. */
const BilingualSectionTitle = ({ english, urdu }) => (
  <View
    style={{
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      width: TABLE_WIDTH,
      marginTop: 6,
      marginBottom: 2,
    }}
  >
    <Text
      style={{
        fontSize: 8,
        fontWeight: "bold",
        fontFamily: "Roboto",
        color: "#000",
      }}
    >
      {english}
    </Text>
    <Text
      style={{
        fontSize: 9,
        fontFamily: "Vazirmatn",
        textAlign: "right",
        color: "#000",
      }}
    >
      {urdu}
    </Text>
  </View>
);

const ThCell = ({ width, label, align }) => (
  <View style={[saleReportStyles.th, { width, textAlign: align || "left" }]}>
    <Text style={saleReportStyles.thValue}>{label}</Text>
  </View>
);

const TdCell = ({ width, value, align }) => (
  <View style={[saleReportStyles.td, { width, textAlign: align || "left" }]}>
    <Text style={saleReportStyles.tdValue}>{value ?? "—"}</Text>
  </View>
);

const TotalRow = ({ labelWidth, amountWidth, label, amount }) => (
  <View style={saleReportStyles.totalsRow}>
    <View
      style={[
        saleReportStyles.td,
        { width: labelWidth, textAlign: "right" },
      ]}
    >
      <Text style={saleReportStyles.tdValue}>{label}</Text>
    </View>
    <TdCell width={amountWidth} value={fmt(amount)} align="right" />
  </View>
);

function PrintSummary3() {
  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");
  const urlParams = new URLSearchParams(window.location.search);
  const Dated = urlParams.get("Dated");

  const [ListOfGernalVouchers, setListOfGernalVouchers] = useState([]);
  const [ListOfReading, setListOfReading] = useState([]);
  const [ListOfSaleDetails, setListOfSaleDetails] = useState([]);
  const [PaymentsGiven, setPaymentGiven] = useState([]);
  const [ListOfExpense, setListOfExpense] = useState([]);
  const [ListOfReceipts, setListOfReceipts] = useState([]);
  const [ListOfCreditPurchase, setListOfCreditPurchase] = useState([]);
  const [ListOfCreditSales, setListOfCreditSale] = useState([]);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Print Summary 3";
    if (!Dated || !UserID || !AccessKey) {
      setLoading(false);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Report/GetDailySummaryReport3",
      headers: { "Content-Type": "application/json" },
      data: {
        UserID,
        AccessKey,
        Dated: moment(Dated).isValid()
          ? moment(Dated).format("YYYY-MM-DD")
          : Dated,
      },
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setListOfReading(response.data.listofReading || []);
          setListOfSaleDetails(response.data.listofSaleDetail || []);
          setData(response.data);
          setListOfGernalVouchers(response.data.listofGeneralVoucher || []);
          setPaymentGiven(response.data.listofPayments || []);
          setListOfExpense(response.data.listofExpenses || []);
          setListOfReceipts(response.data.listofReceipts || []);
          setListOfCreditPurchase(response.data.listofCreditPurchase || []);
          setListOfCreditSale(response.data.listofCreditSales || []);
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
      });
  }, [Dated, UserID, AccessKey]);

  const datedLabel =
    Dated && moment(Dated).isValid()
      ? moment(Dated).format(config.date_format)
      : "—";

  const voucherLabelWidth =
    VOUCHER_COL.sr +
    VOUCHER_COL.voucher +
    VOUCHER_COL.colA +
    VOUCHER_COL.colB +
    VOUCHER_COL.desc;

  const saleLabelWidth =
    SALE_COL.sr +
    SALE_COL.inv +
    SALE_COL.customer +
    SALE_COL.product +
    SALE_COL.vehicle +
    SALE_COL.qty +
    SALE_COL.price;

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={saleReportStyles.page} wrap>
        <PrintHeaderAccount compact />
        <View style={saleReportStyles.section}>
          <View style={saleReportStyles.titleBlock}>
            <Text style={saleReportStyles.pagetitle}>Summary Sheet 3</Text>
            <Text style={saleReportStyles.reportSubtitle}>
              Date: {datedLabel}
            </Text>
          </View>

          <BilingualSectionTitle
            english="Nozzle Details"
            urdu="نوزل کی تفصیلات"
          />
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={NOZZLE_COL.sr} label="Sr.#" />
              <ThCell width={NOZZLE_COL.product} label="Product" />
              <ThCell width={NOZZLE_COL.no} label="No." />
              <ThCell
                width={NOZZLE_COL.previous}
                label="Previous"
                align="right"
              />
              <ThCell
                width={NOZZLE_COL.current}
                label="Current"
                align="right"
              />
              <ThCell
                width={NOZZLE_COL.returned}
                label="Returned"
                align="right"
              />
              <ThCell width={NOZZLE_COL.used} label="Used" align="right" />
            </View>
            {ListOfReading.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={NOZZLE_COL.sr} value={String(index + 1)} />
                <TdCell
                  width={NOZZLE_COL.product}
                  value={item.ProductName || item.ProductCode}
                />
                <TdCell
                  width={NOZZLE_COL.no}
                  value={item.PumpMachineID || item.Pump_No}
                />
                <TdCell
                  width={NOZZLE_COL.previous}
                  value={fmtQty(item.Last_Reading)}
                  align="right"
                />
                <TdCell
                  width={NOZZLE_COL.current}
                  value={fmtQty(item.Current_Reading)}
                  align="right"
                />
                <TdCell
                  width={NOZZLE_COL.returned}
                  value={fmtQty(item.Returned)}
                  align="right"
                />
                <TdCell
                  width={NOZZLE_COL.used}
                  value={fmtQty(item.UsedQuantity)}
                  align="right"
                />
              </View>
            ))}
          </View>

          <BilingualSectionTitle
            english="Sale Details"
            urdu="فروخت کی تفصیلات"
          />
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={SALE_COL.sr} label="Sr.#" />
              <ThCell width={SALE_COL.inv} label="Inv.#" />
              <ThCell width={SALE_COL.customer} label="Customer" />
              <ThCell width={SALE_COL.product} label="Product" />
              <ThCell width={SALE_COL.vehicle} label="Vehicle" />
              <ThCell width={SALE_COL.qty} label="Qty" align="right" />
              <ThCell width={SALE_COL.price} label="Price" align="right" />
              <ThCell width={SALE_COL.amount} label="Amount" align="right" />
            </View>
            {ListOfSaleDetails.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={SALE_COL.sr} value={String(index + 1)} />
                <TdCell width={SALE_COL.inv} value={item.Receipt_No || "—"} />
                <TdCell
                  width={SALE_COL.customer}
                  value={item.Account_BE?.Name || "—"}
                />
                <TdCell
                  width={SALE_COL.product}
                  value={item.Product_BE?.Name || "—"}
                />
                <TdCell width={SALE_COL.vehicle} value={item.Vehicle_No || "—"} />
                <TdCell
                  width={SALE_COL.qty}
                  value={fmtQty(item.Quantity)}
                  align="right"
                />
                <TdCell
                  width={SALE_COL.price}
                  value={fmtQty(item.Price)}
                  align="right"
                />
                <TdCell
                  width={SALE_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <TotalRow
              labelWidth={saleLabelWidth}
              amountWidth={SALE_COL.amount}
              label="Cash Sale"
              amount={data.CashSales}
            />
            <TotalRow
              labelWidth={saleLabelWidth}
              amountWidth={SALE_COL.amount}
              label="Credit Sale"
              amount={data.CreditSales}
            />
            <TotalRow
              labelWidth={saleLabelWidth}
              amountWidth={SALE_COL.amount}
              label="Total Sale"
              amount={data.totalSales}
            />
          </View>

          <BilingualSectionTitle
            english="Vouchers Details"
            urdu="واؤچر کی تفصیلات"
          />
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={VOUCHER_COL.sr} label="Sr.#" />
              <ThCell width={VOUCHER_COL.voucher} label="Voucher No" />
              <ThCell width={VOUCHER_COL.colA} label="Customer Name" />
              <ThCell width={VOUCHER_COL.colB} label="Received In" />
              <ThCell width={VOUCHER_COL.desc} label="Description" />
              <ThCell width={VOUCHER_COL.amount} label="Amount" align="right" />
            </View>
            {ListOfGernalVouchers.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={VOUCHER_COL.sr} value={String(index + 1)} />
                <TdCell width={VOUCHER_COL.voucher} value={item.VoucherNo} />
                <TdCell
                  width={VOUCHER_COL.colA}
                  value={item.Credit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.colB}
                  value={item.Debit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.desc}
                  value={item.Description || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <TotalRow
              labelWidth={voucherLabelWidth}
              amountWidth={VOUCHER_COL.amount}
              label="Total"
              amount={calculateColumnTotal(ListOfGernalVouchers, "Amount")}
            />
          </View>

          <BilingualSectionTitle
            english="Payments Given Details"
            urdu="دی گئی ادائیگیوں کی تفصیلات"
          />
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={VOUCHER_COL.sr} label="Sr.#" />
              <ThCell width={VOUCHER_COL.voucher} label="Voucher No" />
              <ThCell width={VOUCHER_COL.colA} label="From" />
              <ThCell width={VOUCHER_COL.colB} label="To" />
              <ThCell width={VOUCHER_COL.desc} label="Description" />
              <ThCell width={VOUCHER_COL.amount} label="Amount" align="right" />
            </View>
            {PaymentsGiven.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={VOUCHER_COL.sr} value={String(index + 1)} />
                <TdCell width={VOUCHER_COL.voucher} value={item.VoucherNo} />
                <TdCell
                  width={VOUCHER_COL.colA}
                  value={item.Credit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.colB}
                  value={item.Debit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.desc}
                  value={item.Description || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <TotalRow
              labelWidth={voucherLabelWidth}
              amountWidth={VOUCHER_COL.amount}
              label="Total"
              amount={calculateColumnTotal(PaymentsGiven, "Amount")}
            />
          </View>

          <BilingualSectionTitle
            english="Expenses Details"
            urdu="اخراجات کی تفصیلات"
          />
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={VOUCHER_COL.sr} label="Sr.#" />
              <ThCell width={VOUCHER_COL.voucher} label="Voucher No" />
              <ThCell width={VOUCHER_COL.colA} label="From" />
              <ThCell width={VOUCHER_COL.colB} label="To" />
              <ThCell width={VOUCHER_COL.desc} label="Description" />
              <ThCell width={VOUCHER_COL.amount} label="Amount" align="right" />
            </View>
            {ListOfExpense.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={VOUCHER_COL.sr} value={String(index + 1)} />
                <TdCell width={VOUCHER_COL.voucher} value={item.VoucherNo} />
                <TdCell
                  width={VOUCHER_COL.colA}
                  value={item.Credit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.colB}
                  value={item.Debit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.desc}
                  value={item.Description || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <TotalRow
              labelWidth={voucherLabelWidth}
              amountWidth={VOUCHER_COL.amount}
              label="Total"
              amount={calculateColumnTotal(ListOfExpense, "Amount")}
            />
          </View>

          <BilingualSectionTitle
            english="Receipts Details"
            urdu="وصولیوں کی تفصیلات"
          />
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={VOUCHER_COL.sr} label="Sr.#" />
              <ThCell width={VOUCHER_COL.voucher} label="Voucher No" />
              <ThCell width={VOUCHER_COL.colA} label="From" />
              <ThCell width={VOUCHER_COL.colB} label="To" />
              <ThCell width={VOUCHER_COL.desc} label="Description" />
              <ThCell width={VOUCHER_COL.amount} label="Amount" align="right" />
            </View>
            {ListOfReceipts.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={VOUCHER_COL.sr} value={String(index + 1)} />
                <TdCell width={VOUCHER_COL.voucher} value={item.VoucherNo} />
                <TdCell
                  width={VOUCHER_COL.colA}
                  value={item.Credit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.colB}
                  value={item.Debit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.desc}
                  value={item.Description || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <TotalRow
              labelWidth={voucherLabelWidth}
              amountWidth={VOUCHER_COL.amount}
              label="Total"
              amount={calculateColumnTotal(ListOfReceipts, "Amount")}
            />
          </View>

          <BilingualSectionTitle
            english="Credit Purchase Details"
            urdu="ادھار خریداری کی تفصیلات"
          />
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={VOUCHER_COL.sr} label="Sr.#" />
              <ThCell width={VOUCHER_COL.voucher} label="Voucher No" />
              <ThCell width={VOUCHER_COL.colA} label="To" />
              <ThCell width={VOUCHER_COL.colB} label="From" />
              <ThCell width={VOUCHER_COL.desc} label="Description" />
              <ThCell width={VOUCHER_COL.amount} label="Amount" align="right" />
            </View>
            {ListOfCreditPurchase.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={VOUCHER_COL.sr} value={String(index + 1)} />
                <TdCell width={VOUCHER_COL.voucher} value={item.VoucherNo} />
                <TdCell
                  width={VOUCHER_COL.colA}
                  value={item.Credit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.colB}
                  value={item.Debit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.desc}
                  value={item.Description || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <TotalRow
              labelWidth={voucherLabelWidth}
              amountWidth={VOUCHER_COL.amount}
              label="Total"
              amount={calculateColumnTotal(ListOfCreditPurchase, "Amount")}
            />
          </View>

          <BilingualSectionTitle
            english="Credit Sales Details"
            urdu="ادھار فروخت کی تفصیلات"
          />
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={VOUCHER_COL.sr} label="Sr.#" />
              <ThCell width={VOUCHER_COL.voucher} label="Voucher No" />
              <ThCell width={VOUCHER_COL.colA} label="From" />
              <ThCell width={VOUCHER_COL.colB} label="To" />
              <ThCell width={VOUCHER_COL.desc} label="Description" />
              <ThCell width={VOUCHER_COL.amount} label="Amount" align="right" />
            </View>
            {ListOfCreditSales.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={VOUCHER_COL.sr} value={String(index + 1)} />
                <TdCell width={VOUCHER_COL.voucher} value={item.VoucherNo} />
                <TdCell
                  width={VOUCHER_COL.colA}
                  value={item.Credit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.colB}
                  value={item.Debit_Account?.Name || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.desc}
                  value={item.Description || "—"}
                />
                <TdCell
                  width={VOUCHER_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <TotalRow
              labelWidth={voucherLabelWidth}
              amountWidth={VOUCHER_COL.amount}
              label="Total"
              amount={calculateColumnTotal(ListOfCreditSales, "Amount")}
            />
          </View>

          <View
            style={{ marginBottom: 20, marginTop: 0, top: 6, bottom: 6 }}
            fixed
          >
            <Text
              style={{ fontSize: "7pt", color: "#000" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <PDFViewer width="100%" height="100%" fileName="SummarySheet3.pdf">
          <MyDocument />
        </PDFViewer>
      )}
    </div>
  );
}

export default PrintSummary3;
